module.exports = __webpack_public_path__ + "img/LogoEN.22bbccd2.png";